import "./style/style.css";

export function HowToPlay() {
  return (
    <section className="how-to-play-container" id="howtoplay">
      <div className="sticky">
        <h1>How to Play</h1>
        <h5>Step by Step Guide</h5>

        <video muted autoPlay loop controls className="video">
          <source src="/video/how_to_play.mp4" type="video/mp4" />
        </video>
      </div>
      <div className="how-to-play-infos">
        <div className="how-to-play-info">
          <strong>Welcome to EverMines!</strong>
          <p>Experience the next big thing in iGaming!</p>
          <p>Every tile hides a coin or a mine</p>
          <p>Start by placing your bet.</p>
        </div>

        <div className="how-to-play-info">
          <strong>The goal? </strong>
          <p>To cash out before the bomb explodes.</p>
          <p>
            The more coins you uncover, the higher the multiplier— and your
            potential winnings!
          </p>
          <p>
            But beware: if a mine explodes before you cash out, you lose your
            bet.
          </p>
          <p>In this room, there are 3 mines.</p>
        </div>

        <div className="how-to-play-info">
          <strong>Prefer more or less risk?</strong>
          <p>You can adjust the number of mines to suit your strategy</p>
          <p>Higher risk means higher multipliers and bigger potential wins!</p>
          <p>
            Keep an eye on the top bar—it shows the number of coins revealed
            before a mine was hit
          </p>
        </div>

        <div className="how-to-play-info">
          <strong>Want to automate your game?</strong>
          <p>
            Use AUTO PLAY to place bets automatically with your last bet amount
          </p>
          <p>
            Use AUTO CASH OUT to lock in your winnings at a specific multiplier.
          </p>
          <br />
          <p>
            We hope you enjoy thrilling wins and unforgettable moments with this
            exciting game!
          </p>
          <p>
            Ready to try? Scan the QR Code and play the <strong>demo </strong>
            now!
          </p>
        </div>
      </div>
    </section>
  );
}
